import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class FishboneService {

  
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }

  constructor(private http: HttpClient) {
  }

  getFishBoneData(headerId: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.get<any[]>(this.baseUrl + 'find-fishbone', { headers: header, params: { headerId: headerId } });
    return this.http.get<any[]>(this.O3CoreApiUrl + 'ATFishbone/GetFishbone', { headers: header, params: { headerId: headerId } });
  }

  addFishBoneData(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.post<any[]>(this.baseUrl + 'add-fishbone', data, { headers: header });
   return this.http.post<any[]>(this.O3CoreApiUrl + 'ATFishBone/AddFishBone', data, { headers: header });
  }

  updateFishBoneData(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.put<any[]>(this.baseUrl + 'update-fishbone', data, { headers: header });
    return this.http.put<any[]>(this.O3CoreApiUrl + 'ATFishBone/UpdateFishBone', data, { headers: header });
  }

}
